// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__53qQO","col":"styles_col__YSERN","fulfillmentStatus":"styles_fulfillmentStatus__1uUws","emailCol":"styles_emailCol__d21TG"};